import Box from '@mui/material/Box';
import { type TextFieldProps } from '@mui/material/TextField';
import { Input, type InputProps } from '../input';
import { Status } from '../../status';

import type { JSX } from 'react';

export type DateInputFieldProps = TextFieldProps & Pick<InputProps, 'hasError'>;

export const DateInputField = (props: DateInputFieldProps): JSX.Element => {
  const {
    size: _size,
    contentEditable: _contentEditable,
    value,
    hasError,
    InputProps,
    ...rest
  } = props;

  return (
    <Input
      value={value as string}
      size='regular'
      testId='date-input-field'
      hasError={hasError}
      isClearIconShown={true}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <>
            {Boolean(hasError) && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mr: 1,
                }}
              >
                <Status statusLevel='error' size={20} />
              </Box>
            )}
            {InputProps?.endAdornment}
          </>
        ),
      }}
      {...(rest as Omit<TextFieldProps, 'size' | 'contentEditable' | 'value'>)}
    />
  );
};
